export const FOCUS_RING_BRAND_SHADOW_SM = `focus-visible:outline-hidden focus-visible:shadow-[0_0_0_4px_rgb(var(--brand-500)/24%),0_1px_2px_0_rgb(var(--gray-900)/6%),0_1px_3px_0_rgb(var(--gray-900)/10%)]`;

export const FOCUS_RING_ERROR_SHADOW_XS = `focus-visible:outline-hidden focus-visible:shadow-[0px_0px_0px_4px_rgb(var(--error-500)/24%),0px_1px_2px_0px_rgb(var(--gray-900)/5%)]!`;

export const BG_BLUR = `bg-white/80 backdrop-blur-lg`;

export const FOCUS_RING = `focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-white focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-950`;
